export default __webpack_public_path__ + "static/media/TirthankarRoy.ccf3cbea.png";